import { render, staticRenderFns } from "./memberDetailSetting.vue?vue&type=template&id=09987845&"
import script from "./memberDetailSetting.vue?vue&type=script&lang=js&"
export * from "./memberDetailSetting.vue?vue&type=script&lang=js&"
import style0 from "./memberDetailSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports